import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { FiUser, FiCheckCircle, FiAlertCircle } from 'react-icons/fi';
import { FiHelpCircle } from 'react-icons/fi';


const CodeValidation = ({ onValidation }) => {
  const [code, setCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const validateCode = async () => {
    if (!code.trim()) {
      return;
    }

    setLoading(true);
    setError('');
    setSuccess('');

    try {
      // Validar código usando el endpoint GET
      const verificationResponse = await axios.get(
        `https://postula.doms.pe/api/partner-service/v1/2025/october/application-requests/validar?codigo=${code.toUpperCase()}`,
        {
          headers: {
            'api.security.token': 'MiTokenUltraSecretoLouisTech2025'
          }
        }
      );
      
      const verificationData = verificationResponse.data;

      // Verificar si el código es válido
      if (!verificationData.valido) {
        
        return;
      }

      // Verificar que la solicitud esté en estado APROBADO
      if (verificationData.estado !== "APROBADA") {
        
        return;
      }

      setSuccess('loading'); // Usar estado especial para mostrar animación

      // Simular delay para mostrar animación antes de redirigir
      setTimeout(() => {
        // Preparar los datos para pasar al formulario
        const campaignData = {
          valido: verificationData.valido,
          estado: verificationData.estado,
          mensaje: verificationData.mensaje,
          totalPorIp: verificationData.totalPorIp,
          totalPorCodigo: verificationData.totalPorCodigo,
          codigo: code.toUpperCase(),
          seleccionIds: verificationData.seleccionIds || null
        };

        onValidation(true, campaignData, code.toUpperCase());
      }, 2500);

    } catch (error) {
      console.error('Error validating code:', error);
      if (error.response) {
    }
    setLoading(false);
  } finally {
    setLoading(false);
  }
};

  const handleSubmit = (e) => {
    e.preventDefault();
    validateCode();
  };

  return (
    <div className="w-full max-w-lg mx-auto relative">
      {/* Modal de carga sobrepuesto */}
      {success === 'loading' && (
        <div className="fixed inset-0 flex items-center justify-center z-50">
          <div className="bg-white rounded-2xl p-8 shadow-2xl border border-gray-200">
            <div className="flex justify-center">
              <div className="loading-dots">
                <div className="loading-dot"></div>
                <div className="loading-dot"></div>
                <div className="loading-dot"></div>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="mx-auto w-24 h-24 mb-6 flex items-center justify-center">
        <img
          src="/logopartner.png"
          alt="Logo"
          className="w-full h-full object-contain rounded-full shadow-sm"
        />
      </div>

      <div className="form-container rounded-2xl p-8">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-gray-800 mb-2">
            Formulario de Postulación
          </h1>
          <p className="text-gray-600">
            Ingrese el código proporcionado para continuar
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center gap-1">
              Código Único
              <div className="relative group">
                <FiHelpCircle className="w-4 h-4 text-gray-500 cursor-pointer hover:text-gray-700" />
                <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 hidden group-hover:block bg-gray-800 text-white text-xs rounded py-1 px-2 whitespace-nowrap shadow-lg">
                  Codigo proporcionado por selección.
                </div>
              </div>
            </label>
            <input
              type="text"
              value={code}
              onChange={(e) => setCode(e.target.value.toUpperCase())}
              className={`form-input w-full px-4 py-3 rounded-2xl text-center text-lg font-semibold tracking-wider ${error ? 'error' : ''
                }`}
              placeholder="RQXXXXXX"
              maxLength="10"
              disabled={loading}
            />
          </div>

          {error && (
            <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded-xl">
              {error}
            </div>
          )}


          {success !== 'loading' && (
            <button
              type="submit"
              disabled={loading}
              className={`w-full py-3 px-6 rounded-2xl font-semibold text-white text-lg ${loading
                ? 'bg-gray-400 cursor-not-allowed'
                : 'bg-naranja hover:bg-opacity-90 active:bg-opacity-75'
                } transition-all duration-200`}
            >
              {loading ? (
                <div className="flex items-center justify-center">
                  <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white mr-2"></div>
                  Validando...
                </div>
              ) : (
                'Validar Código'
              )}
            </button>
          )}
        </form>

        {success !== 'loading' && (
          <div className="mt-8 text-center">
            <div className="flex justify-center space-x-4">
              <div className="w-4 h-4 bg-naranja rounded-full"></div>
              <div className="w-4 h-4 bg-verde-esmeralda rounded-full"></div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CodeValidation;
